export interface County {
  id?: string;
  name?: string;
  state?: string;
}
